<template>
    <div class="flex flex-col md:flex-row justify-end items-end gap-1">
        <div class="flex items-center gap-1 text-gray-500">
            <Icon
                :name="isCardExpanded ? 'angle-up' : 'angle-down'"
                class="w-3.5 h-3.5"
            />
            <span class="font-medium text-sm"> Details </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        isCardExpanded: {
            type: Boolean,
            required: true,
        },
    })
</script>
